import { __awaiter, __generator, __values } from "tslib";
import localforage from 'localforage';
var ApprovalCommentCache = (function () {
    function ApprovalCommentCache() {
    }
    ApprovalCommentCache.generateKey = function (flowId, userId, modalType, nodeId) {
        if (nodeId) {
            return "" + this.CACHE_PREFIX + flowId + "_" + nodeId + "_" + userId + "_" + modalType;
        }
        return "" + this.CACHE_PREFIX + flowId + "_" + userId + "_" + modalType;
    };
    ApprovalCommentCache.isExpired = function (timestamp) {
        var now = Date.now();
        var expireTime = window.__DEBUG_EXPIRE_TIME__ || this.EXPIRE_HOURS * 60 * 60 * 1000;
        return (now - timestamp) > expireTime;
    };
    ApprovalCommentCache.save = function (flowId, userId, modalType, content, nodeId) {
        return __awaiter(this, void 0, Promise, function () {
            var key, cacheData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.checkAndCleanupStorage()];
                    case 1:
                        _a.sent();
                        key = this.generateKey(flowId, userId, modalType, nodeId);
                        cacheData = {
                            content: content,
                            timestamp: Date.now(),
                            version: this.CACHE_VERSION
                        };
                        return [4, this.store.setItem(key, cacheData)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.warn('Failed to save approval comment cache:', error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.get = function (flowId, userId, modalType, nodeId) {
        return __awaiter(this, void 0, Promise, function () {
            var key, cacheData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        key = this.generateKey(flowId, userId, modalType, nodeId);
                        return [4, this.store.getItem(key)];
                    case 1:
                        cacheData = _a.sent();
                        if (!cacheData) {
                            return [2, null];
                        }
                        if (!this.isExpired(cacheData.timestamp)) return [3, 3];
                        return [4, this.clear(flowId, userId, modalType, nodeId)];
                    case 2:
                        _a.sent();
                        return [2, null];
                    case 3: return [2, cacheData.content];
                    case 4:
                        error_2 = _a.sent();
                        console.warn('Failed to get approval comment cache:', error_2);
                        return [2, null];
                    case 5: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.clear = function (flowId, userId, modalType, nodeId) {
        return __awaiter(this, void 0, Promise, function () {
            var key, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        key = this.generateKey(flowId, userId, modalType, nodeId);
                        return [4, this.store.removeItem(key)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.warn('Failed to clear approval comment cache:', error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.cleanup = function () {
        return __awaiter(this, void 0, Promise, function () {
            var keys, expiredKeys, keys_1, keys_1_1, key, cacheData, e_1_1, error_4;
            var e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 11, , 12]);
                        return [4, this.store.keys()];
                    case 1:
                        keys = _b.sent();
                        expiredKeys = [];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, 8, 9]);
                        keys_1 = __values(keys), keys_1_1 = keys_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!keys_1_1.done) return [3, 6];
                        key = keys_1_1.value;
                        if (!key.startsWith(this.CACHE_PREFIX)) return [3, 5];
                        return [4, this.store.getItem(key)];
                    case 4:
                        cacheData = _b.sent();
                        if (cacheData && this.isExpired(cacheData.timestamp)) {
                            expiredKeys.push(key);
                        }
                        _b.label = 5;
                    case 5:
                        keys_1_1 = keys_1.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 9: return [4, Promise.all(expiredKeys.map(function (key) { return _this.store.removeItem(key); }))];
                    case 10:
                        _b.sent();
                        if (expiredKeys.length > 0) {
                            console.log("Cleaned up " + expiredKeys.length + " expired approval comment caches");
                        }
                        return [3, 12];
                    case 11:
                        error_4 = _b.sent();
                        console.warn('Failed to cleanup approval comment cache:', error_4);
                        return [3, 12];
                    case 12: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.getCacheSize = function () {
        return __awaiter(this, void 0, Promise, function () {
            var keys, totalSize, keys_2, keys_2_1, key, cacheData, dataStr, e_2_1, error_5;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 10, , 11]);
                        return [4, this.store.keys()];
                    case 1:
                        keys = _b.sent();
                        totalSize = 0;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, 8, 9]);
                        keys_2 = __values(keys), keys_2_1 = keys_2.next();
                        _b.label = 3;
                    case 3:
                        if (!!keys_2_1.done) return [3, 6];
                        key = keys_2_1.value;
                        if (!key.startsWith(this.CACHE_PREFIX)) return [3, 5];
                        return [4, this.store.getItem(key)];
                    case 4:
                        cacheData = _b.sent();
                        if (cacheData) {
                            dataStr = JSON.stringify(cacheData);
                            totalSize += new Blob([dataStr]).size;
                        }
                        _b.label = 5;
                    case 5:
                        keys_2_1 = keys_2.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (keys_2_1 && !keys_2_1.done && (_a = keys_2.return)) _a.call(keys_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7];
                    case 9: return [2, totalSize];
                    case 10:
                        error_5 = _b.sent();
                        console.warn('Failed to get cache size:', error_5);
                        return [2, 0];
                    case 11: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.checkAndCleanupStorage = function () {
        return __awaiter(this, void 0, Promise, function () {
            var currentSize, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4, this.getCacheSize()];
                    case 1:
                        currentSize = _a.sent();
                        if (!(currentSize > this.MAX_CACHE_SIZE)) return [3, 3];
                        return [4, this.performLRUCleanup()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3, 5];
                    case 4:
                        error_6 = _a.sent();
                        console.warn('Failed to check storage:', error_6);
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.performLRUCleanup = function () {
        return __awaiter(this, void 0, Promise, function () {
            var keys, cacheItems, keys_3, keys_3_1, key, cacheData, e_3_1, itemsToDelete, keysToDelete, error_7;
            var e_3, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 11, , 12]);
                        return [4, this.store.keys()];
                    case 1:
                        keys = _b.sent();
                        cacheItems = [];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, 8, 9]);
                        keys_3 = __values(keys), keys_3_1 = keys_3.next();
                        _b.label = 3;
                    case 3:
                        if (!!keys_3_1.done) return [3, 6];
                        key = keys_3_1.value;
                        if (!key.startsWith(this.CACHE_PREFIX)) return [3, 5];
                        return [4, this.store.getItem(key)];
                    case 4:
                        cacheData = _b.sent();
                        if (cacheData) {
                            cacheItems.push({ key: key, timestamp: cacheData.timestamp });
                        }
                        _b.label = 5;
                    case 5:
                        keys_3_1 = keys_3.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_3_1 = _b.sent();
                        e_3 = { error: e_3_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (keys_3_1 && !keys_3_1.done && (_a = keys_3.return)) _a.call(keys_3);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7];
                    case 9:
                        cacheItems.sort(function (a, b) { return a.timestamp - b.timestamp; });
                        itemsToDelete = Math.ceil(cacheItems.length * 0.25);
                        keysToDelete = cacheItems.slice(0, itemsToDelete).map(function (item) { return item.key; });
                        return [4, Promise.all(keysToDelete.map(function (key) { return _this.store.removeItem(key); }))];
                    case 10:
                        _b.sent();
                        console.log("LRU cleanup: removed " + keysToDelete.length + " cache items");
                        return [3, 12];
                    case 11:
                        error_7 = _b.sent();
                        console.warn('Failed to perform LRU cleanup:', error_7);
                        return [3, 12];
                    case 12: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.clearAll = function () {
        return __awaiter(this, void 0, Promise, function () {
            var keys, cacheKeys, error_8;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.store.keys()];
                    case 1:
                        keys = _a.sent();
                        cacheKeys = keys.filter(function (key) { return key.startsWith(_this.CACHE_PREFIX); });
                        return [4, Promise.all(cacheKeys.map(function (key) { return _this.store.removeItem(key); }))];
                    case 2:
                        _a.sent();
                        console.log("Cleared all approval comment caches (" + cacheKeys.length + " items)");
                        return [3, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.warn('Failed to clear all caches:', error_8);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.getStats = function () {
        return __awaiter(this, void 0, Promise, function () {
            var keys, cacheKeys, expiredItems, cacheKeys_1, cacheKeys_1_1, key, cacheData, e_4_1, totalSize, error_9;
            var e_4, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 11, , 12]);
                        return [4, this.store.keys()];
                    case 1:
                        keys = _b.sent();
                        cacheKeys = keys.filter(function (key) { return key.startsWith(_this.CACHE_PREFIX); });
                        expiredItems = 0;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, 8, 9]);
                        cacheKeys_1 = __values(cacheKeys), cacheKeys_1_1 = cacheKeys_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!cacheKeys_1_1.done) return [3, 6];
                        key = cacheKeys_1_1.value;
                        return [4, this.store.getItem(key)];
                    case 4:
                        cacheData = _b.sent();
                        if (cacheData && this.isExpired(cacheData.timestamp)) {
                            expiredItems++;
                        }
                        _b.label = 5;
                    case 5:
                        cacheKeys_1_1 = cacheKeys_1.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_4_1 = _b.sent();
                        e_4 = { error: e_4_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (cacheKeys_1_1 && !cacheKeys_1_1.done && (_a = cacheKeys_1.return)) _a.call(cacheKeys_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7];
                    case 9: return [4, this.getCacheSize()];
                    case 10:
                        totalSize = _b.sent();
                        return [2, {
                                totalItems: cacheKeys.length,
                                totalSize: totalSize,
                                expiredItems: expiredItems
                            }];
                    case 11:
                        error_9 = _b.sent();
                        console.warn('Failed to get cache stats:', error_9);
                        return [2, {
                                totalItems: 0,
                                totalSize: 0,
                                expiredItems: 0
                            }];
                    case 12: return [2];
                }
            });
        });
    };
    ApprovalCommentCache.CACHE_PREFIX = 'approval_comment_cache_';
    ApprovalCommentCache.EXPIRE_HOURS = 24;
    ApprovalCommentCache.MAX_CACHE_SIZE = 50 * 1024 * 1024;
    ApprovalCommentCache.CACHE_VERSION = '1.0.0';
    ApprovalCommentCache.store = localforage.createInstance({
        name: 'ApprovalCommentCache',
        storeName: 'approval_comments'
    });
    return ApprovalCommentCache;
}());
export { ApprovalCommentCache };
if (typeof window !== 'undefined') {
    setTimeout(function () {
        ApprovalCommentCache.cleanup();
    }, 5000);
}
